import { Link } from 'react-router-dom';
import { useState, useCallback } from 'react';
import Service from '../../Service/http';
import { useQuery } from 'react-query';
import Loader from '../Loader/Loader';
import { toast } from 'react-toastify';
import Pagination from "@mui/material/Pagination";
import { debounce } from 'lodash';
import { BiPencil } from 'react-icons/bi';
import { VscChevronDown } from "react-icons/vsc";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Fab } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import AddProblem from './AddProblem';
import { TiTick } from 'react-icons/ti';
import { GrAdd } from 'react-icons/gr';
import ProblemSetModal from '../ProblemSet/ProblemSetModal';
import { ClipLoader } from 'react-spinners';

const UpdateProblem = () => {

  const service = new Service();
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [problemName, setProblemName] = useState('');
  const [problemId, setProblemId] = useState('');
  const [siteName, setSiteName] = useState('');
  const [deleteProblemId, setDeleteProblemId] = useState('')
  const [addedProblemId, setAddedProblemId] = useState('');
  const [problemsetLoading, setProblemsetLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const sites = ["CODECHEF", "CODEFORCES", "LEETCODE", "INTERVIEWBIT", "HACKERRANK", "HACKEREARTH", "SPOJ", "GEEKSFORGEEKS", "VJUDGE", "MENTORPICK"]
  
  const dropdownContainerStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '40rem', 
    marginLeft: '0.45rem',
  };

  const selectStyle = {
    width: '100%',
    padding: '0.5rem', 
    paddingRight: '2rem', 
    backgroundColor: '#ffffff', 
    fontSize: '1rem', 
    cursor: 'pointer', 
  };

  const iconStyle = {
    position: 'absolute',
    right: '0.5rem',
    pointerEvents: 'none', 
  };

  const { data, refetch, isLoading: loading } = useQuery(['problems', page, limit], () => {

    const searchParams = new URLSearchParams()
    searchParams.set("page", page.toString())
    searchParams.set("limit", limit.toString())
    searchParams.set("problemName", problemName)
    searchParams.set("problemId", problemId)
    searchParams.set("siteName", siteName)

    return service.get(`api/problems/all?${searchParams.toString()}`);
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true
  })


  const generateOptions = () => {
    const options = [];
    const totalLimit = Math.ceil(data?.result?.pages / 50) + 1;
    for (let i = 1; i < totalLimit; i++) {
      options.push(i * 10)
    }
    return options;
  }

  const handlePageChange = (e, v) => {
    setPage(v);
  }

  const debouncedFetchStatus = useCallback(
    debounce(() => {
      refetch()
    }, 1000), // Adjust the debounce delay as needed
    []
  );

  const handleDebounce = (value, setValue) => {
    setValue(value)
    debouncedFetchStatus();
  };

  const rows = data?.result?.docs?.map((problem, index) => {
    return <tr key={problem._id} className='text-center'>
      <td>{index + 1}</td>
      <td>{problem.problemName}</td>
      <td>{problem.problemId}</td>
      <td>{problem.siteName}</td>
      <td>
          {
            problemsetLoading && (addedProblemId === problem._id || deleteProblemId === problem._id) ? <ClipLoader size={15} color='#3498db'/> : 
            <button 
              className="custom-button text-dark bg-transparent" 
              style={{cursor: 'pointer'}}
              onClick={() => !problem.problemsetProblem ? addProblemToProblemSet(problem._id) : removeProblemFromProblemSet(problem._id)}
          >
              {
                  problem.problemsetProblem ? 
                  <TiTick size={22} color='green'/> : <GrAdd/>
              }
            </button>

          }
      </td>
      <td>
        <Link to={`/admin/edit/problem/${problem._id}`}>
          <BiPencil />
        </Link>
      </td>

    </tr>
  })

  const options = generateOptions().map((value) => {
    return <option value={value}>{value}</option>
  })

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  /* ---------------- Problemset Page Related Functions ------------ */

  const addProblemToProblemSet = (problem_id) => {

    setAddedProblemId(problem_id);
    setProblemsetLoading(true);
    service.put(`api/problemset/add/${problem_id}`).then(response => {
        toast.success(response.result)
        refetch()
    }).catch(error => {
        console.error(error);
        refetch()
    }).finally(() => {
      setProblemsetLoading(false);
      setAddedProblemId('');
    })
    
  }

  const deleteProblemFromProblemSet = ( id ) => {
    
    setProblemsetLoading(true)
    service.delete(`api/problemset/remove/${id}`).then(response => {
        refetch();
        toast.success("Problem Removed From Problemset");
    }).catch(error => {
        console.error(error)
        toast.error("Unable to Remove Problem");
    }).finally(() => {
      setProblemsetLoading(false);
      setDeleteProblemId(false);
    })
  }

  const removeProblemFromProblemSet = (problem_id) => {
    setDeleteProblemId(problem_id);
    setShowModal(true);
  }

  return (

    <>
      {
        !loading ? <> 
        <ProblemSetModal deleteProblemFromProblemSet={deleteProblemFromProblemSet} onHide={() => setShowModal(false)} problemId={deleteProblemId} show={showModal}/>
        <div className="search-header container border-top d-flex" style={{ padding: 10 , paddingTop:30 }}>
          <input type="text" className='form-control mx-2' placeholder='Problem Name' onChange={(e) => handleDebounce(e.target.value, setProblemName)} />
          <input type="text" className='form-control mx-2' placeholder='Problem Id' onChange={(e) => handleDebounce(e.target.value, setProblemId)} />
          <div style={dropdownContainerStyle}>
            <select
              onChange={(e) => handleDebounce(e.target.value, setSiteName)}
              className='form-control'
              style={selectStyle}
              value={siteName}
            >
              <option value="">All - Sites</option> 
              {
                sites.map((site, index) => (
                  <option value={site} key={index}>{site}</option>
                ))
              }
            </select>
            <VscChevronDown style={iconStyle} size={20} />
          </div>
        </div>

          <div className='container d-flex align-items-center justify-content-center my-2 overflow-auto'>
            <table className='table table-striped table-bordered w-100'>
              <thead>
                <tr className='text-center'>
                  <th>#</th>
                  <th>Problem Name</th>
                  <th>Problem Id</th>
                  <th>Site Name</th>
                  <th>Problem Set</th>
                  <th>Edit</th>
                </tr>
              </thead>

              <tbody>
                {
                  rows
                }
              </tbody>
            </table>

            <div>

            </div>
          </div>

          <div className="container d-flex justify-content-between">
            <select
              className="custom-select"
              style={{ width: '4rem', height: '2rem', borderRadius: '5px', border: '1px solid gray', outline: 'none', textAlign: 'center' }}
              onChange={(e) => {
                setLimit(e.target.value)
              }
              }
              value={limit}
            >
              {
                options
              }
            </select>
            <Pagination
              count={data?.result?.pages}
              color="primary"
              defaultPage={1}
              page={page}
              onChange={handlePageChange}
              variant="outlined" shape="rounded"
            />
           <Fab
            aria-label="add"
            style={{
              position: "fixed",
              bottom: "50px",
              right: "6px",
              zIndex: 1000,
              width: "60px",
              height: "60px",
            }}
            onClick={handleClickOpen}
          >
            <AddCircleIcon 
              sx={{ 
                color: '#158cba', 
                fontSize: '30px' 
              }} 
            />
          </Fab>

          <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={true}
            PaperProps={{
                style: {
                    width: 'auto', 
                    maxWidth: 'none', 
                    minWidth: '300px', 
                },
            }}
          >
            <DialogContent
              style={{
                padding: '20px', 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <AddProblem />
            </DialogContent>
          </Dialog>
          </div></> : <Loader />
      }

    </>
  )
}

export default UpdateProblem